<template>
  <v-row class="pt-4">
    <v-col cols="12" xl="9" class="text-justify">
      <v-form
        ref="form"
        v-model="valid"
      >
      <v-card flat class="transparent">
        <v-card-text>
          <v-row>
            <InputField
              :key="i"
              :field="field"
              v-model="formData[field.key]"
              v-for="(field, i) in formFields"
            />
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            color="primary"
            class="text-none"
            @click="goBack"
          >
            {{ $t('assemblyPlanning.exit') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="primary"
            class="text-none"
            :disabled="!valid"
            @click="saveRecord(true)"
          >
            {{ $t('assemblyPlanning.saveExit') }}
          </v-btn>
          <v-btn
            color="primary"
            class="text-none"
            :disabled="!valid"
            @click="saveRecord(false)"
          >
            {{ $t('assemblyPlanning.saveAddNew') }}
          </v-btn>
        </v-card-actions>
      </v-card>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex';
import InputField from './input/InputField.vue';
import { sales } from './salesform.json';

export default {
  name: 'SalesForm',
  components: {
    InputField,
  },
  data() {
    return {
      formData: {},
      valid: false,
    };
  },
  computed: {
    formFields() {
      return sales.fields;
    },
    element() {
      return sales.elementName;
    },
  },
  created() {
    this.resetForm();
  },
  methods: {
    ...mapActions('sales', ['createRecord']),
    async saveRecord(exit) {
      await this.createRecord({ payload: this.formData, element: this.element });
      if (exit) {
        this.goBack();
      }
      this.$refs.form.reset();
    },
    resetForm() {
      // eslint-disable-next-line
      sales.fields.map((f) => this.formData[f.key] = '');
    },
    goBack() {
      this.$router.push({ name: 'sales' });
    },
  },
};
</script>
